import { useOutletContext } from "react-router-dom";
import CompanyAdmin from "@/pages/CompanyAdmin";
import NavigationAdmin from "./NavigationAdmin";
import WorkflowDefinitionsAdmin from "./WorkflowDefinitionsAdmin";

type CompanyContext = { id: string; name: string };

export function CompanyUsersSection() {
  const company = useOutletContext<CompanyContext>();
  return <CompanyAdmin fixedCompanyId={company.id} fixedCompanyName={company.name} />;
}

export function CompanyFeaturesSection() {
  const company = useOutletContext<CompanyContext>();
  return <NavigationAdmin fixedCompanyId={company.id} fixedCompanyName={company.name} />;
}

export function CompanyWorkflowsSection() {
  const company = useOutletContext<CompanyContext>();
  return <WorkflowDefinitionsAdmin fixedCompanyId={company.id} fixedCompanyName={company.name} />;
}